module.exports = __webpack_public_path__ + "img/76200.1f81603c.jpg";